import find from 'lodash/find';

import template from './planDetails.html';
import './planDetails.scss';

export const PlanDetailsModule = angular
    .module('app.components.changePlan.planDetails', [])
    .component('planDetails', {
        template,
        bindings: {
            plan: '<',
            highlight: '<',
            showBorder: '<',
            selectPlanButtonText: '<',
            onPlanSelected: '&',
            isTrial: '<',
            showMenu: '<'
        },
        controller: class PlanDetails {
            $onInit() {
                if (this.plan.alternates) {
                    this.plans = [...this.plan.alternates, this.plan];
                    this.selectedPlanId = this.plans.reduce((id, plan) => {
                        if (plan.displayFirst) return plan.id;
                        return id;
                    }, null);
                }

                this.setDisplayedPlan();

                this.showMenu = this.displayedPlan.showMenu;
            }

            setDisplayedPlan() {
                if (!this.plan.alternates) {
                    this.displayedPlan = this.plan;
                    return;
                }

                if (!this.selectedPlanId) this.selectedPlanId = this.plan.id;

                this.displayedPlan = find(this.plans, { id: this.selectedPlanId });
                this.displayedPlan.nickname = this.displayedPlan.nickname ?
                    this.cleanName(this.displayedPlan.nickname) : this.cleanName(this.displayedPlan.name);
            }

            cleanName(name) {
                if (!name) return;

                return name
                    .replace(/^3M-/, '') // 3M-*
                    .replace(/-\d+(-.+)?$/, '') // *-299-credits
                    .replace(/-\dapp.?$/i, ''); // *-1App
            }

            isCurrentPlan() {
                return this.displayedPlan.isCurrentPlan && !this.isTrial;
            }

            getSelectPlanButtonText() {
                if (this.selectPlanButtonText) {
                    return this.selectPlanButtonText;
                } else if (this.isCurrentPlan()) {
                    return 'Current Plan';
                }

                return 'Let\'s go!';
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/changePlan/planDetails/planDetails.js